import type { FormValues } from './RequestPickupDrawer.types'

export const MODAL_NAME = 'orders.request-pickup'
export const FORM_ID = 'orders.request-pickup'

export const INITIAL_VALUES: FormValues = {
  pickupDate: '',
}
